import React, { useEffect, useState } from "react";
import YMLogo from "./assets/YMLogo";

const Navbar = ({ averageColor, oppositeColor }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <nav
      id="content"
      onMouseOut={() => setHovered(false)}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed top-0 z-40 flex max-h-[56px] min-h-[56px] w-full items-center justify-between bg-white py-[1vh] text-[silver] mix-blend-difference transition-all duration-[200] ease-in-out hover:text-red-500 hover:mix-blend-normal "
      // style={{
      //   mixBlendMode: "difference",
      //   // backgroundImage: `linear-gradient(180deg, ${averageColor} 65% ,   transparent 100%)`,
      // }}
    >
      <div className="pl-[2.5vw]">
        <YMLogo
          size={56}
          // style={{
          //   mixBlendMode: hovered ? "normal" : "difference",
          //   transition: "fill 0.5s",
          // }}
        />
      </div>

      <div
        id="text"
        className="grid grid-flow-col grid-rows-1  items-center justify-center gap-[3vw] p-[2vw] mix-blend-difference "
        style={{
          // color: "black",
          fontFamily: "Orbitron",
          fontWeight: "300",
          WebkitTextStroke: `0.25px #53e639`,
        }}
      >
        {[
          { title: "music", link: "/music" },
          { title: "videos", link: "/videos" },
          // { title: "store", link: "https://yung-men.sellfy.store/" },
        ].map(({ title, link }, index) => (
          <a
            key={title}
            href={link}
            className="flex h-full w-full cursor-pointer items-center rounded-xl px-[10px] py-[5px] hover:bg-[#1af0ec] "
          >
            <p className="text-[max(0.5vw,18px)] font-[900] capitalize tracking-wider  ">
              {title}
            </p>
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
